export const SERVER_TABLE_PANEL_WIDTH = 320;
export const COLUMN_DRAG_ACTIVATION_DISTANCE = 4;
